import type { ReactNode } from "react";
import { Helmet } from "react-helmet-async";

export interface PageLayoutProps {
  readonly title: string;
  readonly description: string;
  readonly children: ReactNode;
  readonly className?: string;
  readonly useContainer?: boolean;
  readonly head?: ReactNode;
}

/**
 * Page-level wrapper for SEO metadata and content styling.
 *
 * Handles <Helmet> (title, description, structured data) and applies
 * the page-enter animation class. Does NOT render <main> — that lives
 * in AppShell / HubSidebarLayout so every page gets the landmark
 * automatically.
 */
export function PageLayout({
  title,
  description,
  children,
  className = "",
  useContainer = false,
  head,
}: PageLayoutProps): JSX.Element {
  const rootClass =
    `page-enter ${useContainer ? "container" : ""} ${className}`.trim();

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {head}
      </Helmet>
      <div className={rootClass}>{children}</div>
    </>
  );
}
